import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Button, Form, Input, Switch} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";
const { TextArea } = Input;


const GlobalBannerSettingsForm = () => {
    const notify = useNotify ()
    const [form] = Form.useForm ();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider ()
    const settingsName = "GlobalBanner"

    const {loaded, error, data: currentSettings} = useQuery ({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    return (
        <>
            {
                (loaded || error) &&
                <Form
                    form={form}
                    labelAlign='left'
                    labelCol={{span: 10}}
                    wrapperCol={{span: 16}}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    <Form.Item valuePropName='checked' label={"Enable " + settingsName} name="ENABLED" initialValue={currentSettings?.['config']?.ENABLED || false}>
                        <Switch defaultChecked={currentSettings?.['config']?.ENABLED == true}/>
                    </Form.Item>

                    <Form.Item label={"Message"} initialValue={currentSettings?.['config']?.message} name="message">
                        <TextArea />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="form-button">Save</Button>
                    </Form.Item>
                </Form>
            }
        </>
    )
}

export default GlobalBannerSettingsForm;
